import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Body1 } from '@ui/Typography'
import { Modal } from '@ui/components/Modal'

import { Box } from '@shared/components/Box'

interface AddToGroupModalProps {
  partnerToTrader?: boolean
  switchMenu: () => void
  onAccept?: () => void
}

export const TradersToPartnerModal: BaseModalType<AddToGroupModalProps> = (props) => {
  const { close, partnerToTrader, switchMenu, onAccept } = props
  const { t } = useTranslation()
  const titleText = partnerToTrader
    ? t('Switch from Partners to Traders Room title')
    : t('Switch from Traders to Partners Area title')

  const bodyText = partnerToTrader
    ? t('Switch from Partners to Traders message transfer new')
    : t('Switch from Traders to Partners message transfer new')

  return (
    <Modal>
      <Modal.Header>{titleText}</Modal.Header>
      <Modal.Body>
        <Box flex align='center' gap='x8'>
          <Body1 whiteSpace='pre-line'>{bodyText}</Body1>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={async () => {
            await close()
            switchMenu()
            onAccept?.()
          }}
        >
          {t('Switch')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
